/**
 * Preloader SVG component
 *
 * @constructor
 */
import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';

const BCoreLoaderWrapper = styled.div`
    width: 64px;
    height: 64px;
    transform: scale(2);
    padding-left: 16px;
`;

export const BCoreLoader: FC<{ title?: string, children?: ReactNode }> = ({ title, children }) => {
    return (
        <FlexBox
            style={{ padding: '8px', paddingTop: '40px' }}
            width={'100%'}
            justify={'center'}
            align={'center'}
            direction={'column'}
            directionMobile={'column'}
        >
            <BCoreLoaderWrapper>
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#333">
                    <g fill="none" fillRule="evenodd">
                        <g transform="translate(1 1)" strokeWidth="2">
                            <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="1s"
                                    repeatCount="indefinite"
                                />
                            </path>
                        </g>
                    </g>
                </svg>
            </BCoreLoaderWrapper>
            <FInter.Text>
                {title}
                {children}
            </FInter.Text>
        </FlexBox>
    );
};
/**
 * Preloader SVG component
 *
 * @constructor
 */
import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';

const BCoreLoaderWrapper = styled.div`
    width: 64px;
    height: 64px;
    transform: scale(2);
    padding-left: 16px;
`;

export const BCoreLoader: FC<{ title?: string, children?: ReactNode }> = ({ title, children }) => {
    return (
        <FlexBox
            style={{ padding: '8px', paddingTop: '40px' }}
            width={'100%'}
            justify={'center'}
            align={'center'}
            direction={'column'}
            directionMobile={'column'}
        >
            <BCoreLoaderWrapper>
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#333">
                    <g fill="none" fillRule="evenodd">
                        <g transform="translate(1 1)" strokeWidth="2">
                            <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="1s"
                                    repeatCount="indefinite"
                                />
                            </path>
                        </g>
                    </g>
                </svg>
            </BCoreLoaderWrapper>
            <FInter.Text>
                {title}
                {children}
            </FInter.Text>
        </FlexBox>
    );
};
